export enum ReviewPurchaserType {
    RewardedBuyer = 'REWARDED_BUYER',
    VerifiedBuyer = 'BUYER',
    Tester = 'TESTER',
    Spontaneous = 'SPONTANEOUS',
}

export const mapReviewPurchaserType = (purchaserType: string): ReviewPurchaserType => {
    const lowerCaseType = purchaserType.toLowerCase();

    switch (lowerCaseType) {
        case 'rewarded_buyer':
            return ReviewPurchaserType.RewardedBuyer;
        case 'buyer':
            return ReviewPurchaserType.VerifiedBuyer;
        case 'tester':
            return ReviewPurchaserType.Tester;
        case 'spontaneous':
        default:
            return ReviewPurchaserType.Spontaneous;
    }
};
